module.exports = __webpack_public_path__ + "assets/cyoujian.e73f84c3eda0073d85e780658eed755e.png";